import { Block as e } from "../../components/FocusBlock.es.js";
import { FactboxModified as t } from "./FactboxModified.es.js";
import { FactboxHeaderItem as n } from "./FactboxHeaderItem.es.js";
import { FilePen as r, X as i } from "lucide-react";
import { Fragment as a, jsx as o, jsxs as s } from "react/jsx-runtime";
import { Transforms as c } from "slate";
//#region lib/Factbox/components/Factbox.tsx
var l = ({ children: l, element: u, options: d, editor: f }) => {
	let p = u?.properties?.created ?? u?.properties?.original_updated ?? "", m = u?.properties?.modified ?? "", h = u?.properties?.original_id, g = d?.removable ?? !1, _ = d?.locale, { headerTitle: v, createdLabel: y, lastModifiedLabel: b, footerTitle: x } = d, S = x ?? "Changes in the factbox text only affects this article";
	return /* @__PURE__ */ o(e, {
		editor: f,
		element: u,
		children: /* @__PURE__ */ s("div", {
			className: "group border-2 rounded border-slate-200",
			children: [
				/* @__PURE__ */ s("div", {
					contentEditable: !1,
					draggable: !0,
					className: "flex justify-start items-center m-1 p-2 bg-slate-100 dark:bg-slate-700 border-b-2 border-slate-200 ps-0.5 pb-0.5 pt-px cursor-default",
					onMouseDown: (e) => {
						e.stopPropagation();
					},
					children: [
						d?.onEditOriginal && typeof d.onEditOriginal == "function" && h ? /* @__PURE__ */ o(n, {
							title: v ?? "Edit the original factbox",
							onMouseDown: (e) => {
								e.preventDefault(), e.stopPropagation(), d.onEditOriginal(h);
							},
							icon: { icon: r }
						}) : null,
						/* @__PURE__ */ s("div", {
							className: "flex flex-col grow",
							children: [p && /* @__PURE__ */ o(t, {
								modified: p,
								modifiedLabel: y ?? "Created",
								locale: _,
								absolute: !0
							}), m && /* @__PURE__ */ o(t, {
								modified: m,
								modifiedLabel: b ?? "Last modified",
								locale: _
							})]
						}),
						g && /* @__PURE__ */ o(a, { children: /* @__PURE__ */ o("div", {
							className: "hidden grow-0 items-center justify-end group-hover:block",
							children: /* @__PURE__ */ o(n, {
								className: "opacity-60 hover:opacity-100",
								icon: { icon: i },
								onMouseDown: (e) => {
									e.preventDefault(), e.stopPropagation();
									let t = f.children.findIndex((e) => e.id === u.id);
									t > -1 && c.removeNodes(f, { at: [t] });
								}
							})
						}) })
					]
				}),
				/* @__PURE__ */ o("div", {
					className: "px-6 pt-1 pb-2",
					children: l
				}),
				/* @__PURE__ */ o("div", {
					contentEditable: !1,
					className: "flex items-center gap-2 text-xs text-red-800 m-1 p-2 dark:text-red-500 bg-slate-100 dark:bg-slate-700 rounded-sm px-2 py-1",
					children: S
				})
			]
		})
	});
};
//#endregion
export { l as Factbox };
